import { css } from '@emotion/react'
import { CSSProperties, memo } from 'react'
import i18n from '../../../../utilities/i18n'
import IconViewers from '../../../Icons/Viewers'
import { palette } from '../../../styles/colors'

const rootStyles = css({
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    width: '100%',
    '& > div': { display: 'flex', marginBottom: 1 },
    '& > span': {
        color: palette.badgePopular,
        fontWeight: 'bold',
    },
})

interface PopularBannerProps {
    text?: string
    viewersStyleOverrides?: CSSProperties
    styleOverrides?: CSSProperties
    iconSize?: number
    hideIcon?: boolean
    viewers: number
}

const PopularBanner = memo((props: PopularBannerProps) => {
    const {
        text = 'in room',
        viewersStyleOverrides = {},
        styleOverrides = {},
        iconSize,
        hideIcon,
        viewers,
    } = props

    return (
        <div
            data-testid="Container__PopularBanner"
            css={rootStyles}
            style={styleOverrides}
        >
            {!hideIcon && (
                <div>
                    <IconViewers
                        title={i18n.t('modelTile.viewers')}
                        size={iconSize}
                    />
                </div>
            )}
            <span style={viewersStyleOverrides}>{viewers}</span>
            {text}
        </div>
    )
})

export default PopularBanner
export { PopularBanner }
